const ACCENT_CLASSES = {
  violet: "bg-(--pastel-violet-soft) text-(--brand-primary)",
  blue: "bg-(--pastel-blue) text-(--status-info)",
  green: "bg-(--pastel-green) text-(--status-success)",
  amber: "bg-(--pastel-amber) text-(--status-warn)",
  rose: "bg-(--pastel-rose) text-(--status-danger)",
};

export default function StatCard({
  label,
  value,
  trend,
  icon,
  accent = "violet",
  className = "",
}) {
  const accentClass = ACCENT_CLASSES[accent] ?? ACCENT_CLASSES.violet;

  return (
    <div
      className={`@container h-full rounded-(--radius-lg) border border-(--border-strong) bg-(--surface-1) px-[18px] py-[17px] ${className}`.trim()}
    >
      <div className="flex h-full items-start gap-[14px]">
        {icon && (
          <div
            className={`flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-[11px] ${accentClass}`}
          >
            {icon}
          </div>
        )}
        <div className="grid h-full min-w-0 flex-1 grid-rows-[auto_1fr_auto]">
          <div className="line-clamp-2 text-[12.5px] font-semibold leading-tight text-(--text-muted)">
            {label}
          </div>
          <div className="flex items-center">
            <div className="truncate text-[23px] font-extrabold leading-tight tracking-[-0.01em] text-(--text-primary)">
              {value}
            </div>
          </div>
          {trend && (
            <div className="truncate text-[11.5px] font-medium leading-tight text-(--text-faint)">
              {trend}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
